import { Reveal, Splash } from "./decor";
import { Baby, GraduationCap, Mail } from "lucide-react";
import { mailto, EMAIL } from "../content";
import { useBooking } from "../BookingContext";

export const FooterCTA = ({ t }) => {
  const { openBooking } = useBooking();
  return (
    <section id="book" className="relative overflow-hidden bg-[#0066FF] py-24 text-white lg:py-32">
      <Splash className="left-1/4 top-0 h-[420px] w-[420px]" color="#FF6B00" />
      <Splash className="right-10 bottom-0 h-[380px] w-[380px]" color="#00C853" delay={0.2} />

      <div className="mx-auto max-w-4xl px-6 text-center lg:px-10">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.35em] text-white/70">
            {t.cta.eyebrow}
          </p>
          <h2 className="font-display text-4xl font-black leading-tight tracking-tight sm:text-6xl">
            {t.cta.title}
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-white/80">{t.cta.body}</p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-col items-stretch justify-center gap-4 sm:flex-row">
            <button
              onClick={() => openBooking("adults")}
              data-testid="cta-adults-button"
              className="group flex items-center justify-center gap-3 rounded-2xl bg-white px-8 py-5 text-lg font-bold text-[#0066FF] shadow-[0_10px_0_0_rgba(0,0,0,0.2)] transition-all hover:-translate-y-1 hover:shadow-[0_14px_0_0_rgba(0,0,0,0.2)]"
            >
              <GraduationCap className="h-6 w-6" />
              {t.cta.adults}
            </button>
            <button
              onClick={() => openBooking("kids")}
              data-testid="cta-kids-button"
              className="group flex items-center justify-center gap-3 rounded-2xl bg-[#FF6B00] px-8 py-5 text-lg font-bold text-white shadow-[0_10px_0_0_#c85400] transition-all hover:-translate-y-1 hover:shadow-[0_14px_0_0_#c85400]"
            >
              <Baby className="h-6 w-6" />
              {t.cta.kids}
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <a
            href={mailto(t.cta.adultsSubject, t.cta.mailBody)}
            data-testid="cta-email-link"
            className="mt-10 inline-flex items-center gap-2 text-base font-semibold text-white/80 underline-offset-4 transition-colors hover:text-white hover:underline"
          >
            <Mail className="h-4 w-4" />
            {EMAIL}
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export const Footer = ({ t }) => (
  <footer className="bg-black py-12 text-white" data-testid="footer">
    <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 text-center lg:flex-row lg:justify-between lg:text-left lg:px-10">
      <img src="/mylingomap-logo.png" alt="My Lingo Map" className="h-14 w-auto rounded-lg bg-white p-1.5 md:h-16" />
      <p className="max-w-md text-xs font-semibold uppercase tracking-[0.25em] text-white/40">
        {t.footer.tagline}
      </p>
      <p className="text-sm text-white/50">{t.footer.rights}</p>
    </div>
  </footer>
);
